// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD1AbH9YQUa-ZhT0olZzOahOqe6rMJ28KE",
  authDomain: "web2-43b04.firebaseapp.com",
  projectId: "web2-43b04",
  storageBucket: "web2-43b04.firebasestorage.app",
  messagingSenderId: "252368249422",
  appId: "1:252368249422:web:7552359ca9c10307ef191f",
  measurementId: "G-N83D95BQR6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app; 